import React from 'react'

interface MiniLineChartProps {
  data?: number[]
  className?: string
}

export const MiniLineChart: React.FC<MiniLineChartProps> = ({ 
  data = [54, 107, 54, 41, 91, 100, 82, 107, 107, 43, 66], 
  className 
}) => {
  return (
    <div className={`absolute bottom-0 h-[124px] overflow-hidden right-0 w-[185px] ${className || ''}`}>
      <div className="absolute bottom-0 flex gap-[8px] h-[107px] items-end left-[11px] w-[169px]">
        {data.map((height, index) => (
          <div
            key={index}
            className="bg-gradient-to-b from-[rgba(197,204,159,0.22)] to-[rgba(197,204,159,0.08)] shrink-0 w-[8px]"
            style={{ height: `${height}px` }}
          />
        ))}
      </div>
      
      {/* Overlay dots for line effect */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 185 124">
        <defs>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="rgba(197,204,159,0.4)" />
            <stop offset="100%" stopColor="rgba(197,204,159,0.1)" />
          </linearGradient>
        </defs>
        
        {/* Line path connecting dots */}
        <path
          d="M 17 70 L 33 17 L 49 70 L 65 83 L 81 33 L 97 24 L 113 42 L 129 17 L 145 17 L 161 81 L 177 58"
          stroke="url(#lineGradient)"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Dots */}
        <circle cx="17" cy="70" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="33" cy="17" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="49" cy="70" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="65" cy="83" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="81" cy="33" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="97" cy="24" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="113" cy="42" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="129" cy="17" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="145" cy="17" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="161" cy="81" r="6" fill="#c5cc9f" fillOpacity="0.8" />
        <circle cx="177" cy="58" r="6" fill="#c5cc9f" fillOpacity="0.9" />
      </svg>
    </div>
  )
}

export default MiniLineChart
